module.exports = __webpack_public_path__ + "assets/img/AuditCover-w960.35417ec5.webp";